import inst from '~/assets/icons/inst.svg';
import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { useWalletIcon } from '~/hooks';
import { WalletType, walletTypeCurrency } from '~/shared';
import { Text } from '../Text';
import { IShopListItemProps } from './ShopListItem.model';
import {
	StyledContainer,
	StyledInstalledContainer,
	StyledNewContainer,
	StyledPrice,
	StyledPriceContainer,
	StyledTitle,
	StyledTitleText,
} from './ShopListItem.styled';

const ShopListItem = ({
	title,
	price,
	walletType,
	id,
	isNew,
	active,
	installed,
	handleClick,
	variantIndex,
	maxVariantIndex,
	allowSelectInstalled,
	...props
}: IShopListItemProps & React.HTMLAttributes<HTMLDivElement>) => {
	const currencyIcon = useWalletIcon(walletTypeCurrency[walletType], true);
	const isSelectable = !installed || allowSelectInstalled;

	return (
		<StyledContainer
			id={id}
			$invertCurrency={walletType !== WalletType.Donate}
			$active={active}
			$installed={installed}
			$selectable={isSelectable}
			onClick={() => {
				handleClick?.();
				playSound(Sound.ClickButton);
			}}
			onMouseEnter={(e) => {
				props?.onMouseEnter?.(e);
				if (isSelectable) {
					playSound(Sound.LinkCursor);
				}
			}}
			{...props}
		>
			{isNew && (
				<StyledNewContainer>
					<Text>NEW</Text>
				</StyledNewContainer>
			)}
			<StyledTitle>
				<StyledTitleText $isNew={isNew}>{title}</StyledTitleText>{' '}
				{variantIndex !== undefined && (
					<span>
						( {variantIndex} / {maxVariantIndex} )
					</span>
				)}
			</StyledTitle>
			{installed ? (
				<StyledInstalledContainer>
					<img src={inst} />
					<Text>Установлено</Text>
				</StyledInstalledContainer>
			) : (
				<StyledPriceContainer>
					<StyledPrice>{price.toLocaleString('ru-RU')}</StyledPrice>
					<CurrencyIcon icon={currencyIcon} size="md" />
				</StyledPriceContainer>
			)}
		</StyledContainer>
	);
};

export { ShopListItem };
